import React from "react";
import { useState } from "react";
import HomepageBody from "../Components/HomepageBody/HomepageBody";
import HomepageHeader from "../Components/HomepageHeader/HomepageHeader";
import NavBar from "../Layout/NavBar/NavBar";
const Homepage = (props) => {
  const openMenu = props.openMenu;
  const onOpen = props.onOpen;
  return (
    <div>
      <NavBar
        language={props.language}
        languages={props.languages}
        // onOpen={(value) => setOpenMenu(value)}
        onOpen={onOpen}
        openMenu={openMenu}
      />
      <HomepageHeader
        language={props.language}
        languages={props.languages}
        openMenu={openMenu}
      />
      <HomepageBody
        language={props.language}
        languages={props.languages}
        openMenu={openMenu}
      />
    </div>
  );
};

export default Homepage;
